/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Nohraclinic API
 * API do Nohraclinic. Sessão web por cookie httpOnly; mobile por bearer. As rotas sob /v1/auth/* que não estão aqui são servidas pelo handler do better-auth, restrito a uma allowlist (ver src/modules/auth/auth.mount.ts): sign-in/email, sign-out, get-session, verify-email, send-verification-email, request-password-reset e reset-password. O cadastro entra só por POST /v1/auth/registro.
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AjustarCreditosDto,
  CreditarDiscussoesDto,
  CreditosAdminControllerExtratoParams,
  ErroResponse,
  ExtratoDeCreditoResponse,
  LancamentoDeCreditoResponse
} from '../model';

import { httpClient } from '../../http-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getCreditosAdminControllerExtratoUrl = (profileId: string,
    params?: CreditosAdminControllerExtratoParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/admin/creditos/${profileId}?${stringifiedParams}` : `/v1/admin/creditos/${profileId}`
}

/**
 * @summary Saldo e extrato de créditos de um usuário
 */
export const creditosAdminControllerExtrato = async (profileId: string,
    params?: CreditosAdminControllerExtratoParams, options?: Parameters<typeof httpClient>[1]): Promise<ExtratoDeCreditoResponse> => {

  return httpClient<ExtratoDeCreditoResponse>(getCreditosAdminControllerExtratoUrl(profileId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCreditosAdminControllerExtratoQueryKey = (profileId: string,
    params?: CreditosAdminControllerExtratoParams,) => {
    return [
    `/v1/admin/creditos/${profileId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getCreditosAdminControllerExtratoQueryOptions = <TData = Awaited<ReturnType<typeof creditosAdminControllerExtrato>>, TError = ErroResponse>(profileId: string,
    params?: CreditosAdminControllerExtratoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditosAdminControllerExtrato>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditosAdminControllerExtratoQueryKey(profileId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditosAdminControllerExtrato>>> = ({ signal }) => creditosAdminControllerExtrato(profileId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: profileId !== null && profileId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof creditosAdminControllerExtrato>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CreditosAdminControllerExtratoQueryResult = NonNullable<Awaited<ReturnType<typeof creditosAdminControllerExtrato>>>
export type CreditosAdminControllerExtratoQueryError = ErroResponse


export function useCreditosAdminControllerExtrato<TData = Awaited<ReturnType<typeof creditosAdminControllerExtrato>>, TError = ErroResponse>(
 profileId: string,
    params: undefined |  CreditosAdminControllerExtratoParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditosAdminControllerExtrato>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof creditosAdminControllerExtrato>>,
          TError,
          Awaited<ReturnType<typeof creditosAdminControllerExtrato>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCreditosAdminControllerExtrato<TData = Awaited<ReturnType<typeof creditosAdminControllerExtrato>>, TError = ErroResponse>(
 profileId: string,
    params?: CreditosAdminControllerExtratoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditosAdminControllerExtrato>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof creditosAdminControllerExtrato>>,
          TError,
          Awaited<ReturnType<typeof creditosAdminControllerExtrato>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCreditosAdminControllerExtrato<TData = Awaited<ReturnType<typeof creditosAdminControllerExtrato>>, TError = ErroResponse>(
 profileId: string,
    params?: CreditosAdminControllerExtratoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditosAdminControllerExtrato>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Saldo e extrato de créditos de um usuário
 */

export function useCreditosAdminControllerExtrato<TData = Awaited<ReturnType<typeof creditosAdminControllerExtrato>>, TError = ErroResponse>(
 profileId: string,
    params?: CreditosAdminControllerExtratoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditosAdminControllerExtrato>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCreditosAdminControllerExtratoQueryOptions(profileId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreditosAdminControllerCreditarUrl = (profileId: string,) => {




  return `/v1/admin/creditos/${profileId}/creditar`
}

/**
 * @summary Credita discussões para o usuário. A descrição é obrigatória — é o rastro.
 */
export const creditosAdminControllerCreditar = async (profileId: string,
    creditarDiscussoesDto: CreditarDiscussoesDto, options?: Parameters<typeof httpClient>[1]): Promise<LancamentoDeCreditoResponse> => {

  return httpClient<LancamentoDeCreditoResponse>(getCreditosAdminControllerCreditarUrl(profileId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(creditarDiscussoesDto)
  }
);}





export const getCreditosAdminControllerCreditarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof creditosAdminControllerCreditar>>, TError,{profileId: string;data: CreditarDiscussoesDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof creditosAdminControllerCreditar>>, TError,{profileId: string;data: CreditarDiscussoesDto}, TContext> => {

const mutationKey = ['creditosAdminControllerCreditar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof creditosAdminControllerCreditar>>, {profileId: string;data: CreditarDiscussoesDto}> = (props) => {
          const {profileId,data} = props ?? {};

          return  creditosAdminControllerCreditar(profileId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreditosAdminControllerCreditarMutationResult = NonNullable<Awaited<ReturnType<typeof creditosAdminControllerCreditar>>>
    export type CreditosAdminControllerCreditarMutationBody = CreditarDiscussoesDto
    export type CreditosAdminControllerCreditarMutationError = ErroResponse

    /**
 * @summary Credita discussões para o usuário. A descrição é obrigatória — é o rastro.
 */
export const useCreditosAdminControllerCreditar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof creditosAdminControllerCreditar>>, TError,{profileId: string;data: CreditarDiscussoesDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof creditosAdminControllerCreditar>>,
        TError,
        {profileId: string;data: CreditarDiscussoesDto},
        TContext
      > => {
      return useMutation(getCreditosAdminControllerCreditarMutationOptions(options), queryClient);
    }
    export const getCreditosAdminControllerAjustarUrl = (profileId: string,) => {




  return `/v1/admin/creditos/${profileId}/ajustar`
}

/**
 * @summary Ajuste manual, positivo ou negativo. É o caminho de correção do ledger.
 */
export const creditosAdminControllerAjustar = async (profileId: string,
    ajustarCreditosDto: AjustarCreditosDto, options?: Parameters<typeof httpClient>[1]): Promise<LancamentoDeCreditoResponse> => {

  return httpClient<LancamentoDeCreditoResponse>(getCreditosAdminControllerAjustarUrl(profileId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(ajustarCreditosDto)
  }
);}





export const getCreditosAdminControllerAjustarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof creditosAdminControllerAjustar>>, TError,{profileId: string;data: AjustarCreditosDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof creditosAdminControllerAjustar>>, TError,{profileId: string;data: AjustarCreditosDto}, TContext> => {

const mutationKey = ['creditosAdminControllerAjustar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof creditosAdminControllerAjustar>>, {profileId: string;data: AjustarCreditosDto}> = (props) => {
          const {profileId,data} = props ?? {};

          return  creditosAdminControllerAjustar(profileId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreditosAdminControllerAjustarMutationResult = NonNullable<Awaited<ReturnType<typeof creditosAdminControllerAjustar>>>
    export type CreditosAdminControllerAjustarMutationBody = AjustarCreditosDto
    export type CreditosAdminControllerAjustarMutationError = ErroResponse

    /**
 * @summary Ajuste manual, positivo ou negativo. É o caminho de correção do ledger.
 */
export const useCreditosAdminControllerAjustar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof creditosAdminControllerAjustar>>, TError,{profileId: string;data: AjustarCreditosDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof creditosAdminControllerAjustar>>,
        TError,
        {profileId: string;data: AjustarCreditosDto},
        TContext
      > => {
      return useMutation(getCreditosAdminControllerAjustarMutationOptions(options), queryClient);
    }
